import React, { useState } from "react";
import { Eye, Download, FileText } from "lucide-react";
import { fileUrl } from "@/lib/apiClient";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function DocRecord({ doc, dateLabel }) {
  const [open, setOpen] = useState(false);
  const url = doc.storage_path ? fileUrl(doc.storage_path) : null;
  const isPdf = (doc.ext || "").toLowerCase() === "pdf";
  return (
    <div className="py-6 border-b border-npst-line last:border-0" data-testid="doc-record">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
        <div className="flex gap-4">
          <div className="mt-1 text-npst-gold"><FileText size={20} /></div>
          <div>
            {(doc.order_date || doc.doc_date) && (
              <div className="text-[11px] font-sans font-bold uppercase tracking-[0.18em] text-npst-gold mb-1">{doc.order_date || doc.doc_date}</div>
            )}
            <div className="font-serif text-xl text-npst-ink leading-snug">{doc.title}</div>
            {(doc.category || doc.court || doc.authority) && (
              <div className="text-sm text-npst-muted mt-1">{[doc.category, doc.court || doc.authority].filter(Boolean).join(" · ")}</div>
            )}
            {doc.description && <p className="text-sm text-npst-inkSoft mt-2 max-w-xl leading-relaxed">{doc.description}</p>}
          </div>
        </div>
        {url && (
          <div className="flex items-center gap-4 sm:pt-1 shrink-0">
            {isPdf && (
              <button onClick={() => setOpen(true)} data-testid="view-document-btn" className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-npst-navy hover:text-npst-gold transition-colors">
                <Eye size={15} /> View
              </button>
            )}
            <a href={url} target="_blank" rel="noopener noreferrer" download data-testid="download-document-btn" className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.12em] text-npst-navy hover:text-npst-gold transition-colors">
              <Download size={15} /> Download
            </a>
          </div>
        )}
      </div>
      {isPdf && (
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogContent className="max-w-5xl w-[95vw] h-[85vh] p-0 overflow-hidden">
            <iframe title={doc.title} src={url} className="w-full h-full border-0" />
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
